export const EXCLUDED_EMAIL_DOMAINS = ['@sbbuild.ru', '@sbdevelop.ru'];

export const checkExcludedEmail = (value: string) => {
  return EXCLUDED_EMAIL_DOMAINS.some(domain => value.trim().endsWith(domain));
}